import { Signature } from '@phosphor-icons/react';

export default Signature;
